import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Twitter, ArrowRight } from 'lucide-react';

/**
 * Template 5: TARA — Editorial Chic Footer
 * Charcoal bg, cream text, 4 columns, editorial feel
 */
const Footer = () => {
    const navigate = useNavigate();

    return (
        <footer className="bg-[#1A1A1A] text-[#FAF9F6]" style={{ fontFamily: "'Outfit', sans-serif" }}>
            {/* Main Footer */}
            <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16 lg:py-20">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">

                    {/* Brand Column */}
                    <div className="lg:col-span-1">
                        <h3
                            className="text-2xl md:text-3xl text-[#FAF9F6] mb-4 tracking-[0.06em]"
                            style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600 }}
                        >
                            TARA
                        </h3>
                        <p className="text-[#71717A] text-sm leading-relaxed mb-6 font-light max-w-[280px]">
                            Where editorial elegance meets Indian craftsmanship. Curating fashion stories that celebrate heritage with a modern voice.
                        </p>
                        <div className="flex gap-3">
                            <a href="#" className="w-9 h-9 border border-[#71717A]/30 flex items-center justify-center hover:border-[#FAF9F6] hover:text-white transition-all duration-300 text-[#71717A]">
                                <Instagram size={16} />
                            </a>
                            <a href="#" className="w-9 h-9 border border-[#71717A]/30 flex items-center justify-center hover:border-[#FAF9F6] hover:text-white transition-all duration-300 text-[#71717A]">
                                <Facebook size={16} />
                            </a>
                            <a href="#" className="w-9 h-9 border border-[#71717A]/30 flex items-center justify-center hover:border-[#FAF9F6] hover:text-white transition-all duration-300 text-[#71717A]">
                                <Twitter size={16} />
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4
                            className="text-xs tracking-[0.2em] uppercase text-[#FAF9F6] mb-5 font-medium"
                        >
                            Explore
                        </h4>
                        <ul className="space-y-3">
                            {[
                                { label: 'Home', path: '/template5' },
                                { label: 'Shop Collection', path: '/template5/shop' },
                                { label: 'Our Story', path: '/template5/about' },
                                { label: 'Contact', path: '/template5/contact' },
                                { label: 'Track Orders', path: '/template5/orders' },
                            ].map((link) => (
                                <li key={link.path}>
                                    <span
                                        onClick={() => navigate(link.path)}
                                        className="text-[#71717A] text-sm font-light cursor-pointer hover:text-[#FAF9F6] transition-colors duration-300"
                                    >
                                        {link.label}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Customer Care */}
                    <div>
                        <h4
                            className="text-xs tracking-[0.2em] uppercase text-[#FAF9F6] mb-5 font-medium"
                        >
                            Customer Care
                        </h4>
                        <ul className="space-y-3">
                            {[
                                { label: 'Shipping & Returns', path: '/template5/shipping-exchange' },
                                { label: 'Privacy Policy', path: '/template5/privacy-policy' },
                                { label: 'Terms & Conditions', path: '/template5/terms-conditions' },
                                { label: 'FAQs', path: '/template5/faqs' },
                            ].map((link) => (
                                <li key={link.path}>
                                    <span
                                        onClick={() => navigate(link.path)}
                                        className="text-[#71717A] text-sm font-light cursor-pointer hover:text-[#FAF9F6] transition-colors duration-300"
                                    >
                                        {link.label}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Newsletter */}
                    <div>
                        <h4
                            className="text-xs tracking-[0.2em] uppercase text-[#FAF9F6] mb-5 font-medium"
                        >
                            The Edit
                        </h4>
                        <p className="text-[#71717A] text-sm font-light leading-relaxed mb-4">
                            Subscribe for editorial features, new arrivals, and exclusive previews.
                        </p>
                        <div className="flex border-b border-[#71717A]/30 pb-2">
                            <input
                                type="email"
                                placeholder="Your email address"
                                className="flex-1 bg-transparent text-sm text-[#FAF9F6] placeholder-[#71717A] outline-none font-light"
                            />
                            <button className="text-[#FAF9F6] hover:opacity-70 transition-opacity">
                                <ArrowRight className="w-4 h-4" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="border-t border-[#2C2C2C]">
                <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8 py-5 md:py-6">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-3">
                        <p className="text-[#71717A] text-xs font-light tracking-wide">
                            &copy; 2026 TARA. All rights reserved.
                        </p>
                        <p className="text-[#71717A] text-xs font-light tracking-wide">
                            Crafted with care in India
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
